import React from "react";
import HomeSeo from "./HomeSeo";
import { NavLink } from "react-router-dom";

function ThankYouPage() {
  return (
    <div>
      <HomeSeo />
      <div className="site-main">
        <section className="prt-row error-404">
          <div className="container-fluid mb-5">
            <div className="row align-items-center">
              <div className="col-lg-12 col-md-12">
                <div className="page-content-main text-center">
                  <div className="page-content">
                    <h2>
                      <i className="fa fa-check-circle" aria-hidden="true" />
                    </h2>
                    <h3>Thank You!</h3>
                    <p>
                      We appreciate your submission. Your response has been
                      received successfully. We’ll be in touch shortly.
                    </p>
                  </div>
                  <div>
                    <NavLink
                      className="prt-btn prt-btn-size-md prt-btn-shape-round prt-btn-style-fill prt-btn-color-gradiant"
                      to="/"
                    >
                      Back to Home
                    </NavLink>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default ThankYouPage;
